import SpinnerLoading from 'common/components/SpinnerLoading';

const customCatalogs = {
  CatalogCode: () => ({
    component: import(
      /* webpackChunkName: "CatalogCode" */ 'components/Catalog/CatalogCode'
    ),
    loading: SpinnerLoading,
    delay: 200,
  }),
  CatalogCodeModal: () => ({
    component: import(
      /* webpackChunkName: "CatalogCodeModal" */ 'components/Catalog/CatalogCodeModal'
    ),
    loading: SpinnerLoading,
    delay: 200,
  }),
  CatalogChakanaCode: () => ({
    component: import(
      /* webpackChunkName: "CatalogChakanaCode" */ 'components/Catalog/CatalogChakanaCode'
    ),
    loading: SpinnerLoading,
    delay: 200,
  }),
  CatalogChakanaCodeModal: () => ({
    component: import(
      /* webpackChunkName: "CatalogChakanaCodeModal" */ 'components/Catalog/CatalogChakanaCodeModal'
    ),
    loading: SpinnerLoading,
    delay: 200,
  }),
  CatalogCinemaCode: () => ({
    component: import(
      /* webpackChunkName: "CatalogCinemaCode" */ 'components/Catalog/CatalogCinemaCode'
    ),
    loading: SpinnerLoading,
    delay: 200,
  }),
  CatalogCinemaCodeModal: () => ({
    component: import(
      /* webpackChunkName: "CatalogCinemaCodeModal" */ 'components/Catalog/CatalogCinemaCodeModal'
    ),
    loading: SpinnerLoading,
    delay: 200,
  }),
  CatalogTalentClassCode: () => ({
    component: import(
      /* webpackChunkName: "CatalogTalentClassCode" */ 'components/Catalog/CatalogTalentClassCode/CatalogTalentClassCode.vue'
    ),
    loading: SpinnerLoading,
    delay: 200,
  }),
  CatalogTalentClassCodeModal: () => ({
    component: import(
      /* webpackChunkName: "CatalogTalentClassCodeModal" */ 'components/Catalog/CatalogTalentClassCodeModal/CatalogTalentClassCodeModal.vue'
    ),
    loading: SpinnerLoading,
    delay: 200,
  }),
  CatalogNuchaActivityModal: () => ({
    component: import(
      /* webpackChunkName: "CatalogNuchaActivityModal" */ 'components/Catalog/CatalogNuchaActivityModal'
    ),
    loading: SpinnerLoading,
    delay: 200,
  }),
  CatalogPLPModal: () => ({
    component: import(
      /* webpackChunkName: "CatalogPLPModal" */ 'components/Catalog/CatalogPLPModal'
    ),
    loading: SpinnerLoading,
    delay: 200,
  }),
  CatalogComboActivityModal: () => ({
    component: import(
      /* webpackChunkName: "CatalogComboActivityModal" */ 'components/Catalog/CatalogComboActivityModal'
    ),
    loading: SpinnerLoading,
    delay: 200,
  }),
  CatalogCuponPedidosYaActivityModal: () => ({
    component: import(
      /* webpackChunkName: "CatalogCuponPedidosYaActivityModal" */ 'components/Catalog/CatalogCuponPedidosYaActivityModal'
    ),
    loading: SpinnerLoading,
    delay: 200,
  }),
  CatalogReservationConfigModal: () => ({
    component: import(
      /* webpackChunkName: "CatalogReservationConfigModal" */ 'components/Catalog/CatalogReservationConfigModal'
    ),
    loading: SpinnerLoading,
    delay: 200,
  }),
  CatalogSpecialReservationCodeModal: () => ({
    component: import(
      /* webpackChunkName: "CatalogSpecialReservationCodeModal" */ 'components/ReservationModal'
    ),
    loading: SpinnerLoading,
    delay: 200,
  }),
  CatalogFriendsDayLotteryActivityModal: () => ({
    component: import(
      /* webpackChunkName: "CatalogFriendsDayLotteryActivityModal" */ 'components/Catalog/CatalogFriendsDayLotteryActivityModal'
    ),
    loading: SpinnerLoading,
    delay: 200,
  }),
  CatalogWhileSuppliesLastActivityModal: () => ({
    component: import(
      /* webpackChunkName: "CatalogWhileSuppliesLastActivityModal" */ 'components/Catalog/CatalogWhileSuppliesLastActivityModal'
    ),
    loading: SpinnerLoading,
    delay: 200,
  }),
  CatalogMajaActivityModal: () => ({
    component: import(
      /* webpackChunkName: "CatalogMajaActivityModal" */ 'components/Catalog/CatalogMajaActivityModal'
    ),
    loading: SpinnerLoading,
    delay: 200,
  }),
  CatalogMajaCode: () => ({
    component: import(
      /* webpackChunkName: "CatalogMajaCode" */ 'components/Catalog/CatalogMajaCode'
    ),
    loading: SpinnerLoading,
    delay: 200,
  }),
  CatalogInterbank2022Modal: () => ({
    component: import(
      /* webpackChunkName: "CatalogInterbank2022Modal" */ 'components/Catalog/CatalogInterbankModal'
    ),
    loading: SpinnerLoading,
    delay: 200,
  }),
};

export default customCatalogs;
